import { createContext, useContext } from 'react'

import type { Lang } from '@/features/mitra/lib/copy'

/**
 * The register a card's labels are drawn in: the answer's, set once by
 * `Projection` around everything it draws.
 *
 * A context and not a prop because the A2UI catalogue components (`Facts`,
 * `Grid`, `Tiles`, `Withheld`) are mounted by the A2UI renderer from the
 * engine's messages, and no prop of ours reaches them. Without it every label
 * they drew was English whatever the question's script (wow retest 2, B8).
 * English outside a `Projection`, which is what those cards always drew.
 */
export const LabelLangContext = createContext<Lang>('en')

export function useLabelLang(): Lang {
  return useContext(LabelLangContext)
}
